import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useOrg } from "@/context/OrgContext";

const FacilityContext = createContext(null);

export function FacilityProvider({ children }) {
  const { activeOrgId } = useOrg();
  const [facilities, setFacilities] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    if (!activeOrgId) {
      setFacilities([]);
      setLoaded(true);
      return;
    }
    try {
      const { data } = await api.get("/facilities");
      setFacilities(Array.isArray(data) ? data : []);
    } catch (e) {
      setFacilities([]);
    } finally {
      setLoaded(true);
    }
  }, [activeOrgId]);

  // Fetch once per org
  useEffect(() => { refresh(); }, [refresh]);

  // Allow other components to trigger refresh after CRUD on facilities
  useEffect(() => {
    const handler = () => refresh();
    window.addEventListener("cl:facilities-changed", handler);
    return () => window.removeEventListener("cl:facilities-changed", handler);
  }, [refresh]);

  return (
    <FacilityContext.Provider value={{ facilities, loaded, refresh }}>
      {children}
    </FacilityContext.Provider>
  );
}

export const useFacilities = () => {
  const ctx = useContext(FacilityContext);
  if (!ctx) throw new Error("useFacilities must be inside FacilityProvider");
  return ctx;
};
